import React from 'react';

import { GuestStatus } from 'types/guest.types';
import { FilledCheckIcon } from 'components/common/icons/FilledCheckIcon';
import { MaybeUnselectedIcon } from 'components/common/icons/MaybeUnselectedIcon';
import { DARK_PURPLE, YELLOW } from 'constants/colours';
import CancelCircleIcon from 'components/common/icons/CancelCircleIcon';
import HourglassEmptyIcon from 'components/common/icons/HourglassEmptyIcon';

type RsvpSettingsConfig = {
  text: string;
  backgroundColor: string;
  textColor: string;
  icon: JSX.Element;
};

export const RsvpSettings: Partial<Record<GuestStatus, RsvpSettingsConfig>> = {
  [GuestStatus.CONFIRMED]: {
    text: 'Going',
    backgroundColor: 'tw-bg-positive-green-light',
    textColor: 'tw-text-positive-green',
    icon: <FilledCheckIcon />
  },
  [GuestStatus.CONFIRMED_WITH_INCOMPLETE_SURVEY]: {
    text: 'Going',
    backgroundColor: 'tw-bg-positive-green-light',
    textColor: 'tw-text-positive-green',
    icon: <FilledCheckIcon />
  },
  [GuestStatus.INTERESTED]: {
    text: 'Maybe',
    backgroundColor: 'tw-bg-yellow-light',
    textColor: 'tw-text-yellow',
    icon: <MaybeUnselectedIcon color={YELLOW} />
  },
  [GuestStatus.CANCELLED]: {
    text: 'Not going',
    backgroundColor: 'tw-bg-negative-red-light',
    textColor: 'tw-text-negative-red',
    icon: <CancelCircleIcon />
  },
  [GuestStatus.WAITLISTED]: {
    text: 'Waitlisted',
    backgroundColor: 'tw-bg-accent-purple-light',
    textColor: 'tw-text-accent-purple',
    icon: <HourglassEmptyIcon color={DARK_PURPLE} />
  }
};
